module.exports = __webpack_public_path__ + "img/3397ebdf-8bde-42ea-ba0f-a475c8167e27.49e6c65d.jpg";